import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const QUESTIONNAIRES_QUESTIONNAIRE_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/questionnaires',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:Questionnaires',
        layout: eLayoutType.application,
        order: 13,
        requiredPolicy: 'Enova.Questionnaires',
      },
    ]);
  };
}
